<template lang="pug">
  .benefits-wrap.xs-f-small.lg-f-medium.max-at-tweak
    table.benefits-table
      caption.color-white.upper.xs-f-small.lg-f-medium.max-at-tweak why become a member
      
      template(v-for="(benefit, index) in membershipBenefits")
        tr
          th.check.membership
            i.icon-check-nobox.xs-f-large.max-at-tweak(aria-label="check")
          th.check
          th.benefit.text-left.xs-f-small.max-at-tweak(v-html="benefit" scope="row")
        template(v-if="index == 0 && firstTimeBenefits && (!cdata.activeSubscriber && !cdata.formerSubscriber)")
          tr(v-for="firstTimeBenefit in firstTimeBenefits")
            th.check.membership
              i.icon-check-nobox.xs-f-large.max-at-tweak(aria-label="check")
            th.check
            th.benefit.text-left.xs-f-small.max-at-tweak(v-html="firstTimeBenefit" scope="row")
      tr(v-for="benefit in oneTimeBenefits")
        th.check.membership
          i.icon-check-nobox.xs-f-large.max-at-tweak(aria-label="check")
        th.check.one-time
          i.icon-check-nobox.xs-f-large.max-at-tweak(aria-label="check")
        th.benefit.text-left.xs-f-small.max-at-tweak(v-html="benefit" scope="row")

</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: "BenefitsTable",

    props: {
      firstTimeBenefits: {
        type: Array,
        default: () => {
          return [];
        }
      },

      membershipBenefits: {
        type: Array,
        default: () => {
          return [];
        }
      },

      oneTimeBenefits: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },

    computed: {
      ...mapState('customer', ['cdata'])
    }
  }
</script>

<style scoped lang="stylus">
  .benefits-wrap
    position relative
    
    &:before
      content ''
      position absolute
      top 0
      left 0
      right 0
      height 2.5em
      background-color #9fbce4
      
    .benefits-table
      position relative
      width 100%
      max-width 32em
      margin 0 auto
      
      caption
        background-color #9fbce4
        text-align center
        padding 0.5em
        
      th
        padding 0.5em
        vertical-align top
        
      .membership
        background-color #d7e2f4
        
      .one-time
        background-color color-fog-light
        
      .benefit
        padding-left 1em
        
</style>
